import React from 'react'
import { connect } from 'react-redux'
import ForgetUserNameFormComponent  from './ForgetUserNameFormComponent'
import ForgetUserNameConfirmComponent from './ForgetUserNameConfirmComponent'

class ForgetUserNameAppImplComponent extends React.Component {
    constructor(props){
        super(props);
        this.cmeUno = props.cmeUno;

    }

    render(){
        const cmeUno = this.cmeUno;
        switch(this.props.forgetUserName.page){
            case "confirm":
                return (<ForgetUserNameConfirmComponent cmeUno={cmeUno} />);
            default:
                return (<ForgetUserNameFormComponent
                    cmeUno={cmeUno}
                />);
        }

    }
}


const mapStateToProp = (state={}, ownProps) => ({
    forgetUserName: state.forgetUserName,
    ...ownProps
});

const ForgetUserNameAppComponent = connect(mapStateToProp)(ForgetUserNameAppImplComponent);
export default ForgetUserNameAppComponent;